module.exports = __webpack_public_path__ + "static/media/area b.c98770d2.kra";